import { IFeature } from 'mod/featureV2/interface';
import { isPhone } from 'base/utils/client';

export const scaleVideo: IFeature = {
    moduleId: 'scaleVideo',
    type: 'scaleVideo',
    title: 'scaleVideo',
    space: {
        paddingBottom: 0,
    },
    config: {
        width: 1200, //视频原始宽度
        height: 900, //视频原始高度
        // frameScrollDistance: 25, //一帧对应的页面滚动距离, 默认值为 25

        // transitionSpeed: isPhone ? 0 : 5,
        // stay: 20, //一帧对应的页面滚动距离, 默认值为 0

        transitionSpeed: 0,
        stay: 0, //一帧对应的页面滚动距离, 默认值为 0

        backup: 'file-asset/file/62205f7a09e5dc4661cdcd6640e32305/1703665032125/output.m3u8',
        src: 'file-asset/file/6a850710f4ee9020a478fa0caff005dc.mp4',
        poster: 'asset/width-3840/picture/fd86506cd62c23660cc6118d045e00af.jpg',
    }
};